import { useEffect, useMemo, useState } from "react";
import WorkspaceTabFrame from "@/components/WorkspaceTabFrame";
import { useLocation, useOutlet } from "react-router-dom";

export default function PersistentWorkspaceOutlet({ tabs = [] }) {
  const outlet = useOutlet();
  const location = useLocation();
  const activeKey = location.pathname + location.search;

  const openPathsKey = [
    "/dashboard",
    ...tabs
      .filter((tab) => tab && typeof tab.path === "string")
      .map((tab) => tab.path),
  ]
    .filter((path, index, paths) => paths.indexOf(path) === index)
    .join("\n");

  const openKeys = useMemo(
    () => new Set(openPathsKey.split("\n")),
    [openPathsKey]
  );

  const [cache, setCache] = useState({});

  useEffect(() => {
    setCache((previous) => {
      let changed = false;
      const next = { ...previous };

      if (outlet && next[activeKey] !== outlet) {
        next[activeKey] = outlet;
        changed = true;
      }

      for (const key of Object.keys(next)) {
        if (!openKeys.has(key) && key !== activeKey) {
          delete next[key];
          changed = true;
        }
      }

      return changed ? next : previous;
    });
  }, [activeKey, outlet, openKeys]);

  const entries =
    cache[activeKey] !== undefined
      ? cache
      : outlet
        ? { ...cache, [activeKey]: outlet }
        : cache;

  return (
    <div className="workspace-tab-content">
      {Object.entries(entries).map(([key, element]) => (
        <WorkspaceTabFrame
          key={key}
          tabId={key}
          active={key === activeKey}
        >
          {element}
        </WorkspaceTabFrame>
      ))}
    </div>
  );
}
